import React, { useRef, useEffect, useCallback, useState } from 'react';
import { fetch, fetchByJSON, GetDataFrameInfo, getProp, useCachedData, useSimpleForm, useToggleGroup, toUnicode } from '../../util/util'
import './index.css'
import { push } from 'connected-react-router'
import { useSelector, useDispatch } from 'react-redux'
import { actions as DataSetActions } from '../../reducer/dataset'
import { actions as OptionActions } from '../../reducer/option'
import { actions as PresetActions } from '../../reducer/preset'
import { Checkbox, Modal, MultiSelect, Label, Input } from '../../util/ui'
import { DropDown, Button, ButtonGroup } from '../../util/ui_components';
import Table from '../common/table'
import Tip from '../common/tip'
import { InlineTip } from '../common/tip';
import LinearRegressionOptions from './option/regression/linearRegression'
import DecisionTreeRegressionOptions from './option/regression/decisiontreeRegression'
import RandomForestsRegressionOptions from './option/regression/randomforestsRegression'
import SVMRegressionOptions from './option/regression/svmRegression'
import LogisticRegressionOptions from './option/classification/logisticRegression'
import DecisionTreeClassifierOptions from './option/classification/decisiontreeClassifier'
import RandomForestClassifierOptions from './option/classification/randomforestClassifier'
import SVMClassifierOptions from './option/classification/svmClassifier'
import NaiveBayesClassifierOptions from './option/classification/bayesClassifier'
import KNeighborsClassifier from './option/classification/kNeighborsClassifier';
import KMeansOptions from './option/clustering/kmeans'
import AgglomerativeOptions from './option/clustering/agglomerative'
import AprioriOptions from './option/associate_rule/apriori'
import SARIMAOptions from './option/time_series_analysis/sarima'
import {thebeConfigR} from '../../util/thebeConfigs'
import { usePageKernel, attachCells } from '../../util/thebeSession'
import { construct } from 'core-js/fn/reflect';
import authHeader from "../../services/auth-header";
//cdn.datatables.net/1.10.24/js/jquery.dataTables.min.js
//cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css
const OptionModels = {
    regression: { 'Linear Regression': LinearRegressionOptions, 'Decision Tree Regression': DecisionTreeRegressionOptions, 'Random Forests Regression': RandomForestsRegressionOptions, 'SVM Regression': SVMRegressionOptions }, //DecisionTreeOptions, RandomForestsOptions, SuportVectorMachineOptions
    classification: { 'Logistic Regression': LogisticRegressionOptions, 'Decision Tree Classifier': DecisionTreeClassifierOptions, 'Random Forests Classifier': RandomForestClassifierOptions, 'SVM Classifier': SVMClassifierOptions, 'Naive Bayes Classifier': NaiveBayesClassifierOptions, 'K Nearest Neighbors Classifier': KNeighborsClassifier },
    clustering: { 'K-means': KMeansOptions },//, 'Agglometrative': AgglomerativeOptions},
    associate_rule: { 'Apriori': AprioriOptions },
    time_series_analysis: { 'Seasonal ARIMA': SARIMAOptions }
}

// const initialCode = data=>`import pandas as pd
// from io import StringIO
// import matplotlib.pyplot as plt
// import numpy as np
// import math
// import matplotlib.pyplot as plt
// import plotly.express as px

// data_json = StringIO(r"""${toUnicode(data)}""")
// df = pd.read_json(data_json) 
// print(df.head(5))
// `

const MethodSampleFile = {
    'regression': 'house_price_prediction_regression.csv',
    'classification': 'credit_card_default_classification.csv',
    'clustering': 'Mall_Customers_clustering.csv'
}

async function getSampleCodeData(filename, existing) {


}
const GetDisplayCode = (method) => {
    return optionCode[method]``
}
const formula = "formula <- as.formula(paste0(\"\\`\", Y, \"\\` ~ \", paste(X, collapse = \" + \")))";

const getCodeFromResult = (option, model, result, do_training) => {
    if (do_training) {
        console.log(result)
        return DisplayCode[model](result)
    } else {
        return PredictionCode[model](result)
    }
}
const InitialCode = {
    regression: code => `
library(jsonlite)
data_json <- '${code}'
# Convert JSON to a list
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)
`,

    classification: code => `
library(jsonlite)
data_json <- '${code}'
# Convert JSON to a list
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)
`,

    clustering: code => `
library(jsonlite)
data_json <- '${code}'
# Convert JSON to a list
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)
`,

    associate_rule: code => `
library(jsonlite)
data_json <- '${code}'
# Convert JSON to a list
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)

transform_transaction <- function(val) {
    if (val <= 0) {
      return(0)
    }
    if (val >= 1) {
      return(1)
    }
  }
  
df$Quantity <- 1
`,

time_series_analysis: code => `
library(jsonlite)
data_json <- '${code}'
# Convert JSON to a list
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)
`
}

const PredictionCode = {
    'Linear Regression': code => `

    # Multiple independent variables
    X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
    # One dependent variable, our target variable
    Y <- "${"\`" +code.finalY+"\`"}"
    
    # Split the dataset into two parts: training dataset and testing dataset
    set.seed(0)
    # sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
    sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
    test_indices <- sample(seq_len(nrow(df)), size = sample_size)
    
    train_data <- df[-test_indices, ]
    test_data <- df[test_indices, ]
    
    ${linearRegressionFormula}
    model <- lm(formula, data = train_data)
    # Get the summary of the linear model
    model_summary <- summary(model)
    
    # Print the model summary
    print(model_summary)
    
    Y_pred <- predict(model, newdata = test_data)
    cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
    mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
    cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`,

    'Decision Tree Regression': code => `

# multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
# sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

# Load necessary library
library(rpart)

# Build the decision tree regression model
model <- rpart(
  formula = as.formula(paste(Y, "~", paste(X, collapse = " + "))),
  data = train_data,
  method = "anova",  # Equivalent to 'mse' for criterion in Python
  control = rpart.control(
    maxdepth = ifelse(!is.null(${code.param_max_depth}), ${code.param_max_depth}, NA),
    maxcompete = ifelse(!is.null(${code.param_splitter}), ${code.param_splitter == "random"}, NA),
    maxsurrogate = ifelse(!is.null(${code.param_max_features}), ${code.param_max_features}, NA),
    usesurrogate = 2,
    xval = 0
  )
)

# Get the summary of the decision tree model
print(summary(model))

# Predict values for the test dataset
Y_pred <- predict(model, newdata = test_data)

cat("Predicted results of the testing dataset: \n", Y_pred, "\n")

# Calculate Mean Absolute Error (MAE)
mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`,

    'SVM Regression': code => `

# Prediction of SVM Regression

# Load necessary library
if (!requireNamespace("e1071", quietly = TRUE)) {
    install.packages("e1071")
}
library(e1071)

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into training and testing datasets
set.seed(0)
sample_size <- floor(0.7 * nrow(df))
train_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[train_indices, ]
test_data <- df[-train_indices, ]

# Build the model, allowing users to modify parameters
model <- svm(
    formula = as.formula(paste(Y, "~", paste(X, collapse = " + "))),
    data = train_data,
    type = "eps-regression",
    kernel = ${code.param_kernel ? `"${code.param_kernel}"` : '"radial"'},
    gamma = ${code.param_gamma ? code.param_gamma : 0.01},
    cost = ${code.param_C ? code.param_C : 1.0}
)

# Get the summary of the model
model_summary <- summary(model)
print(model_summary)

# Prepare data for prediction
X_pred <- data.frame(${code.finalVar.map(e => `'${e}' = c(${code[`SVM Regression${e}`]})`).join(', ')})

# Predict the target variable for the testing dataset
Y_pred <- predict(model, newdata = X_pred)

# Print predictions
cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
`,

    'Decision Tree Classifier': code => `
# Prediction of Decision Tree Classifier
# import libraries
from sklearn.tree import DecisionTreeClassifier

# multiple independent variales
X = [${code.finalVar.map(e => `'${e}'`).join(',')}]
# one dependent variable, our target variable
Y = '${code.finalY}'

# build a model, users can modify parameters
model = DecisionTreeClassifier(criterion=${code.param_criterion?`'${code.param_criterion}'`:`'gini'`}, max_depth=${code.param_max_depth?code.param_max_depth:`None`}, max_leaf_nodes=${code.param_max_leaf_nodes?code.param_max_leaf_nodes:`None`}) 

# fit input data for prediction
X_pred = pd.DataFrame({${code.finalVar.map(e => `'${e}': [${code[`Decision Tree Classifier${e}`]}]`).join(', ')}})

# fit model to train, and predict testing dataset
Y_pred = model.fit(df[X], df[Y]).predict(X_pred) 
print("Print predicted results of testing dataset: ", X_pred, Y_pred)
`,

    'Random Forests Classifier': code => `
# Prediction of Random Forests Classifier
# import libraries
from sklearn.ensemble import RandomForestClassifier

# multiple independent variales
X = [${code.finalVar.map(e => `'${e}'`).join(',')}]
# one dependent variable, our target variable
Y = '${code.finalY}'

# build a model, users can modify parameters
model = RandomForestClassifier(max_depth=${code.param_max_depth?code.param_max_depth:`None`}, n_estimators=${code.param_n_estimators?code.param_n_estimators:100}, criterion=${code.param_criterion?`'${code.param_criterion}'`:`'gini'`}, max_leaf_nodes=${code.param_max_leaf_nodes?code.param_max_leaf_nodes:`None`})

# fit input data for prediction
X_pred = pd.DataFrame({${code.finalVar.map(e => `'${e}': [${code[`Random Forests Classifier${e}`]}]`).join(', ')}})

# fit model to train, and predict testing dataset
Y_pred = model.fit(df[X], df[Y]).predict(X_pred) 
print("Print predicted results of testing dataset: ", X_pred, Y_pred)
`,

    'SVM Classifier': code => `
# Prediction of SVM Classifier
# import libraries
from sklearn.svm import SVC

# multiple independent variales
X = [${code.finalVar.map(e => `'${e}'`).join(',')}]
# one dependent variable, our target variable
Y = '${code.finalY}'

# build a model, users can modify parameters
model = SVC(kernel=${code.param_kernel?`'${code.param_kernel}'`:`'rbf'`}, gamma=${code.param_gamma?code.param_gamma:0.01}, C=${code.param_C?code.param_C:1.0})

# fit input data for prediction
X_pred = pd.DataFrame({${code.finalVar.map(e => `'${e}': [${code[`SVM Classifier${e}`]}]`).join(', ')}})

# fit model to train, and predict testing dataset
Y_pred = model.fit(df[X], df[Y]).predict(X_pred) 
print("Print predicted results of testing dataset: ", X_pred, Y_pred)
`,

    'Naive Bayes Classifier': code => `
# Prediction of Naive Bayes Classifier
# import libraries
from sklearn.naive_bayes import GaussianNB

# multiple independent variales
X = [${code.finalVar.map(e => `'${e}'`).join(',')}]
# one dependent variable, our target variable
Y = '${code.finalY}'

# build a model, users can modify parameters
model = GaussianNB()

# fit input data for prediction
X_pred = pd.DataFrame({${code.finalVar.map(e => `'${e}': [${code[`Naive Bayes Classifier${e}`]}]`).join(', ')}})

# fit model to train, and predict testing dataset
Y_pred = model.fit(df[X], df[Y]).predict(X_pred) 
print("Print predicted results of testing dataset: ", X_pred, Y_pred)
`,

    'K Nearest Neighbors Classifier': code => `
# Prediction of K Nearest Neighbors Classifier
# import libraries
from sklearn.neighbors import KNeighborsClassifier

# multiple independent variales
X = [${code.finalVar.map(e => `'${e}'`).join(',')}]
# one dependent variable, our target variable
Y = '${code.finalY}'

# build a model, users can modify parameters
model = KNeighborsClassifier(n_neighbors=${code.neighbors?code.neighbors:5},weights=${code.weights?`'${code.weights}'`:`'uniform'`}, algorithm=${code.algorithm?`'${code.algorithm}'`:'auto'}, leaf_size=${code.leaf_size?code.leaf_size:30}, p=${code.p?code.p:2}, metric=${code.d_metric?`'${code.d_metric}'`:`'minkowski'`})

# fit input data for prediction
X_pred = pd.DataFrame({${code.finalVar.map(e => `'${e}': [${code[`K Nearest Neighbors Classifier${e}`]}]`).join(', ')}})

# fit model to train, and predict testing dataset
Y_pred = model.fit(df[X], df[Y]).predict(X_pred) 
print("Print predicted results of testing dataset: ", X_pred, Y_pred)
`,
}

const DisplayCode = {
    'Linear Regression': code => (`
# Demo of Linear Regression in R

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

${formula}
model <- lm(formula, data = train_data)
# Get the summary of the linear model
model_summary <- summary(model)

# Print the model summary
print(model_summary)

Y_pred <- predict(model, newdata = test_data)
cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`),

    'Decision Tree Regression': code => `
# Demo of Decision tree Regression in R
if (!requireNamespace("tree", quietly = TRUE)) {
    install.packages("tree")
}

library(tree)

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
# sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

${formula}
model <- tree(formula, data = train_data)

# Get the summary of the linear model
model_summary <- summary(model)

# Print the model summary
print(model_summary)
plot(model, main = "Decision Tree")
text(model, pretty = 0, cex = 0.8)
Y_pred <- predict(model, newdata = test_data)
cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`,

    'Random Forests Regression': code => `
# Demo of Random  Forests tree Regression in R
if (!requireNamespace("randomForest", quietly = TRUE)) {
    install.packages("randomForest")
}

library(randomForest)

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
# sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

${formula}
model <- randomForest(formula, data = train_data, ntree = 100, importance = TRUE)

# Get the summary of the linear model
model_summary <- summary(model)

# Print the model summary
print(model_summary)

Y_pred <- predict(model, newdata = test_data)
cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`,

    'SVM Regression': code => `
# Demo of SVM
if (!requireNamespace("e1071", quietly = TRUE)) {
    install.packages("e1071")
}

library(e1071)

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
# sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

${formula}
model <- svm(formula, data = train_data, type = "eps-regression", kernel = "radial", cost = 1, epsilon = 0.1)

# Get the summary of the linear model
model_summary <- summary(model)

# Print the model summary
print(model_summary)

Y_pred <- predict(model, newdata = test_data)
cat("Predicted results of the testing dataset: \n", Y_pred, "\n")
mean_absolute_error <- mean(abs(test_data[[Y]] - Y_pred))
cat("Mean Absolute Error: ", mean_absolute_error, "\n")
`,

    'Logistic Regression': code => `
# Demo of Logistic Regression in R

if (!requireNamespace("caret", quietly = TRUE)) {
    install.packages("caret", quiet = TRUE)
}

suppressWarnings(suppressPackageStartupMessages({
    library(ggplot2)
    library(lattice)
    library(caret)
}))

# Multiple independent variables
X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# One dependent variable, our target variable
Y <- "${code.finalY}"

# Ensure column names do not have unexpected spaces
colnames(df) <- trimws(colnames(df))

# Convert Y to a binary factor (as required for logistic regression)
df[[Y]] <- as.factor(ifelse(df[[Y]] > median(df[[Y]]), 1, 0))

# Split the dataset into two parts: training dataset and testing dataset
set.seed(0)
# sample_size <- floor(ifelse(!is.null(${code.test_size}), ${code.test_size} / 100, 0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size)

train_data <- df[-test_indices, ]
test_data <- df[test_indices, ]

${formula}
model <- glm(formula, data = train_data, family = binomial())

# Get the summary of the linear model
model_summary <- summary(model)

# Print the model summary
print(model_summary)

Y_prob <- predict(model, newdata = test_data, type = "response")
Y_pred <- ifelse(Y_prob > 0.5, 1, 0)
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")
accuracy <- mean(Y_pred == test_data[[Y]])
cat("Accuracy: ", accuracy, "\n")

# Confusion Matrix
confusion_matrix <- table(Predicted = Y_pred, Actual = test_data[[Y]])
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Compute Precision, Recall, and F1-Score
TP <- diag(confusion_matrix)
FP <- colSums(confusion_matrix) - TP
FN <- rowSums(confusion_matrix) - TP

precision <- TP / (TP + FP)
recall <- TP / (TP + FN)
f1_score <- 2 * (precision * recall) / (precision + recall)

metrics <- data.frame(
    Class = colnames(confusion_matrix),
    Precision = round(precision, 3),
    Recall = round(recall, 3),
    F1_Score = round(f1_score, 3)
)

cat("Detailed metrics (similar to classification_report):")
print(metrics)
`
    ,

    'Decision Tree Classifier': code => `
# Demo of Decision Tree Classifier
# Note: All variables except metrics are changed automatically based on user's option

if (!requireNamespace("rpart", quietly = TRUE)) {
    install.packages("rpart", quiet = TRUE)
}

suppressMessages(library(rpart))

X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"

colnames(df) <- trimws(colnames(df))

# Ensure target variable is a factor (needed for classification)
df[[Y]] <- as.factor(df[[Y]])

# split the dataset into two parts: training dataset and testing dataset
set.seed(${code.param_random_state?code.param_random_state:0})
df <- df[sample(nrow(df)), ] 
# sample_size <- floor(ifelse(!is.null(${code.test_size}),${code.test_size} / 100,0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size, replace = FALSE)

train_data <- df[-test_indices, ]
test_data  <- df[test_indices, ]

# build formula
${formula}

#rplart's split parameter
rpart_split <- if (${code.param_criterion ? 'TRUE' : 'FALSE'}) {
  if ("${code.param_criterion}" == "gini") "gini" else "information"
} else {
  "gini"
}

#control list for r part
ctrl <- rpart.control(
  maxdepth = ${code.param_max_depth?code.param_max_depth:5}
  )

model <- rpart(
  formula,
  data   = train_data,
  method = "class",
  parms  = list(split = rpart_split),
  control = ctrl
)

# Print model summary
print(model)

# Predict on the test dataset
Y_pred <- predict(model, newdata = test_data, type = "class")
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")

# Compute accuracy
accuracy <- mean(Y_pred == test_data[[Y]])
cat("Accuracy:", round(accuracy, 3), "\n")

# Compute Confusion Matrix
confusion_matrix <- table(Predicted = Y_pred, Actual = test_data[[Y]])
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Copmute precision, recall, and F1-score
TP <- diag(confusion_matrix)
FP <- colSums(confusion_matrix) - TP
FN <- rowSums(confusion_matrix) - TP

precision <- TP / (TP + FP)
recall <- TP / (TP + FN)
f1_score <- 2 * (precision * recall) / (precision + recall)

metrics <- data.frame(
    Class = colnames(confusion_matrix),
    Precision = round(precision, 3),
    Recall = round(recall, 3),
    F1_Score = round(f1_score, 3)
)

cat("Detailed metrics (similar to classification_report):")
print(metrics)
`
    ,
    'Random Forests Classifier': code => `
# Demo of Random Forests Classifier

if (!requireNamespace("randomForest", quietly = TRUE)) {
    install.packages("randomForest")
}

suppressMessages(library(randomForest))

X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"
# split the dataset into two parts: training dataset and testing dataset
set.seed(${code.param_random_state?code.param_random_state:0}) 
# sample_size <- floor(ifelse(!is.null(${code.test_size}),${code.test_size} / 100,0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size, replace = FALSE)

train_data <- df[-test_indices, ]
test_data  <- df[test_indices, ]

X_train <- train_data[X]
X_test <- test_data[X]
Y_train <- train_data[[Y]]
Y_test <- test_data[[Y]]

n_estimators <- ${code.param_n_estimators?code.param_n_estimators:100}
max_depth <- ${code.param_max_depth?code.param_max_depth:3}

# Build and train the Random Forest model
model <- randomForest(
  x = X_train,
  y = as.factor(Y_train),
  ntree = n_estimators,
  maxnodes = max_depth,
  importance = TRUE
)

# Print model summary
print(model)

# Predict on the test dataset
Y_pred <- predict(model, newdata = X_test)
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")

# Ensure predicted and actual values have the same levels
Y_pred <- factor(Y_pred, levels = levels(factor(Y_test)))
Y_test <- factor(Y_test, levels = levels(factor(Y_test)))

# Calculate accuracy
accuracy <- mean(Y_pred == Y_test)
cat("Accuracy:", round(accuracy, 3), "\n")

# Compute confusion matrix
confusion_matrix <- table(Predicted = Y_pred, Actual = Y_test)
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Compute precision, recall, and F1-score
TP <- diag(confusion_matrix)
FP <- colSums(confusion_matrix) - TP
FN <- rowSums(confusion_matrix) - TP

# Avoid division by zero
precision <- ifelse(TP + FP == 0, 0, TP / (TP + FP))
recall <- ifelse(TP + FN == 0, 0, TP / (TP + FN))
f1_score <- ifelse(precision + recall == 0, 0, 2 * (precision * recall) / (precision + recall))

# Print detailed metrics (similar to classification_report)
cat("\nDetailed metrics (similar to classification_report):\n")
metrics <- data.frame(
  Class = rownames(confusion_matrix),
  Precision = round(precision, 3),
  Recall = round(recall, 3),
  F1_Score = round(f1_score, 3)
)
print(metrics)
`
    ,
    'SVM Classifier': code => `
# Demo of SVM Classifier
# Note: All variables except metrics are changed automatically based on user's option

if (!requireNamespace("e1071", quietly = TRUE)) {
    install.packages("e1071", dependencies = TRUE, quiet = TRUE)
}

suppressMessages(library(e1071))

X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"
# split the dataset into two parts: training dataset and testing dataset
set.seed(${code.param_random_state?code.param_random_state:0}) 
# sample_size <- floor(ifelse(!is.null(${code.test_size}),${code.test_size} / 100,0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size, replace = FALSE)

train_data <- df[-test_indices, ]
test_data  <- df[test_indices, ]

X_train <- train_data[X]
X_test <- test_data[X]
Y_train <- train_data[[Y]]
Y_test <- test_data[[Y]]

# Parameters for the SVM model
kernel_type <- ${code.param_kernel?`'${code.param_kernel}'`:`'radial'`}
gamma_value <- ${code.param_gamma?code.param_gamma:0.01}
C_value <- ${code.param_C?code.param_C:1.0}

# build a model, users can modify parameters
model <- svm(
    x = X_train,
    y = Y_train,
    kernel = kernel_type,
    gamma = gamma_value,
    cost = C_value
)

# Print model summary
print(summary(model))

# Predict on the test dataset
Y_pred <- predict(model, newdata = X_test)
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")

all_levels <- union(levels(factor(Y_pred)), levels(factor(Y_test)))
Y_pred <- factor(Y_pred, levels = all_levels)
Y_test <- factor(Y_test, levels = all_levels)

# Calculate accuracy
accuracy <- mean(Y_pred == Y_test)
cat("Accuracy:", accuracy, "\n")

# Compute confusion matrix
confusion_matrix <- table(Predicted = Y_pred, Actual = Y_test)
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Compute precision, recall, and F1-score
TP <- diag(confusion_matrix)
FP <- colSums(confusion_matrix) - TP
FN <- rowSums(confusion_matrix) - TP

# Avoid division by zero
precision <- ifelse(TP + FP == 0, 0, TP / (TP + FP))
recall <- ifelse(TP + FN == 0, 0, TP / (TP + FN))
f1_score <- ifelse(precision + recall == 0, 0, 2 * (precision * recall) / (precision + recall))

cat("\nDetailed metrics (similar to classification_report):\n")
metrics <- data.frame(
  Class = rownames(confusion_matrix),
  Precision = round(precision, 3),
  Recall = round(recall, 3),
  F1_Score = round(f1_score, 3)
)
print(metrics)
`
    ,
    'Naive Bayes Classifier': code => `
# Demo of Naive Bayes Classifier
# Note: All variables except metrics are changed automatically based on user's option

if (!requireNamespace("e1071", quietly = TRUE)) {
    install.packages("e1071", dependencies = TRUE, quiet = TRUE)
}

suppressMessages(library(e1071))

X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"
# split the dataset into two parts: training dataset and testing dataset
set.seed(${code.param_random_state?code.param_random_state:0}) 
# sample_size <- floor(ifelse(!is.null(${code.test_size}),${code.test_size} / 100,0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size, replace = FALSE)

train_data <- df[-test_indices, ]
test_data  <- df[test_indices, ]

X_train <- train_data[X]
X_test <- test_data[X]
Y_train <- train_data[[Y]]
Y_test <- test_data[[Y]]

model <- naiveBayes(
    x = X_train,
    y = as.factor(Y_train)
)

# Print model summary
print(model)

# Predict on the test dataset
Y_pred <- predict(model, newdata = X_test)

# Ensure levels of predicted and actual match
all_levels <- union(levels(factor(Y_pred)), levels(factor(Y_test)))
Y_pred <- factor(Y_pred, levels = all_levels)
Y_test <- factor(Y_test, levels = all_levels)

# Display predicted results
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")

# Calculate confusion matrix
confusion_matrix <- table(Predicted = Y_pred, Actual = Y_test)
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Compute metrics: precision, recall, and F1-score
TP <- diag(confusion_matrix)
FP <- colSums(confusion_matrix) - TP
FN <- rowSums(confusion_matrix) - TP

# Avoid division by zero
precision <- ifelse(TP + FP == 0, 0, TP / (TP + FP))
recall <- ifelse(TP + FN == 0, 0, TP / (TP + FN))
f1_score <- ifelse(precision + recall == 0, 0, 2 * (precision * recall) / (precision + recall))

# Display metrics
cat("\nDetailed metrics (similar to classification_report):\n")
metrics <- data.frame(
  Class = rownames(confusion_matrix),
  Precision = round(precision, 3),
  Recall = round(recall, 3),
  F1_Score = round(f1_score, 3)
)
print(metrics)
`
    ,
    'K Nearest Neighbors Classifier': code => `
# Demo of K Nearest Neighbors Classifier
# Note: All variables except metrics are changed automatically based on user's option
    
if (!requireNamespace("class", quietly = TRUE)) {
    install.packages("class", quiet = TRUE)
}

suppressMessages(library(class))

X <- c(${code.finalVar.map(e => `'${e}'`).join(',')})
# one dependent variable, our target variable
Y <- "${code.finalY}"

# Convert the target variable to a factor
df[[Y]] <- as.factor(df[[Y]])

# split the dataset into two parts: training dataset and testing dataset
set.seed(${code.param_random_state?code.param_random_state:0}) 
# sample_size <- floor(ifelse(!is.null(${code.test_size}),${code.test_size} / 100,0.3) * nrow(df))
sample_size <- floor(ifelse(!is.null(df), 0.3, 1) * nrow(df))
test_indices <- sample(seq_len(nrow(df)), size = sample_size, replace = FALSE)
train_data <- df[-test_indices, ]
test_data  <- df[test_indices, ]

train_X <- train_data[, X, drop = FALSE]
test_X  <- test_data[, X, drop = FALSE]
train_Y <- train_data[[Y]]
test_Y  <- test_data[[Y]]

# build formula
formula <- ${formula}

# build a model, users can modify parameters

num_neighbors <- ${code.neighbors?code.neighbors:5}
algorithm <- ${code.algorithm?`'${code.algorithm}'`:'auto'}
distance_metric <- ${code.d_metric?`'${code.d_metric}'`:`'minkowski'`}
weights=${code.weights?`'${code.weights}'`:`'uniform'`}

# Train the KNN model and make predictions
Y_pred <- knn(
    train = train_X,
    test = test_X,
    cl = train_Y,
    k = num_neighbors
)


# Display predicted results
cat("Predicted results of the testing dataset:\n", Y_pred, "\n")


# Compute accuracy
accuracy <- mean(Y_pred == test_Y)
cat("Accuracy:", round(accuracy, 3), "\n")

confusion_matrix <- table(Predicted = Y_pred, Actual = test_Y)
cat("Confusion Matrix:\n")
print(confusion_matrix)

# Function to calculate metrics for each class
compute_metrics <- function(cm) {
    TP <- diag(cm)
    FP <- colSums(cm) - TP
    FN <- rowSums(cm) - TP
    precision <- TP / (TP + FP)
    recall <- TP / (TP + FN)
    f1_score <- 2 * (precision * recall) / (precision + recall)
    metrics <- data.frame(
        Class = names(TP),
        Precision = round(precision, 3),
        Recall = round(recall, 3),
        F1_Score = round(f1_score, 3)
    )
    return(metrics)
}

# Calculate metrics
metrics <- compute_metrics(confusion_matrix)
cat("\nDetailed metrics (similar to classification_report):\n")
print(metrics)
`

    ,
    'K-means': code => `
# Demo of K-means
# Note: Only one variable "X" is changed automatically based on user's option,
# other parameters are just example.

if (!requireNamespace("ggplot2", quietly = TRUE)) {
    install.packages("ggplot2", quiet = TRUE)
}

suppressMessages(library(ggplot2))

# Check if df exists and is a valid dataframe
if (!exists("df") || !is.data.frame(df) || nrow(df) == 0 || ncol(df) == 0) {
    stop("Error: The dataset df is missing, empty, or not a valid data frame.")
}

# Independent variables
X <- c(${code.variablesx.map(e => `'${e}'`).join(',')})


# Normalize dataset
scaled_data <- as.data.frame(scale(df[, X, drop = FALSE]))

# Build K-means model
set.seed(NULL)
model <- kmeans(scaled_data, centers = 3, nstart = 25)

# Add predicted clusters to the dataset
df$Clusters <- as.factor(model$cluster)

# Combine clusters with original variables
labeled_data <- cbind(scaled_data, Cluster = df$Clusters)

# Plot clusters using ggplot2 (alternative to seaborn pairplot)
if (length(X) == 2) {
    ggplot(labeled_data, aes_string(x = X[1], y = X[2], color = "Cluster")) +
        geom_point(size = 3) +
        theme_minimal() +
        ggtitle("K-means Clustering") +
        theme(legend.position = "right")
} else {
    plot(
        scaled_data[[1]],
        col = df$Clusters,
        pch = 19,
        main = "K-means Clustering",
        xlab = X[1],
        ylab = "Scaled Value"
    )
}
`
    ,

    'Apriori': code => `
# Demo of Apriori
# Note: Only two variables "transid" and "transitem" are changed automatically based on user's option,
# other parameters are just example.

if (!requireNamespace("arules", quietly = TRUE)) {
    install.packages("arules", quiet = TRUE)
}

suppressMessages(library(arules))


# Variables for transaction IDs and items
transid <- "${code.trans_id}"
transitem <- "${code.trans_item}"

# Create a transaction list manually without libraries
basket_data <- split(df[[transitem]], df[[transid]])
transactions <- as(basket_data, "transactions")

# Apply the Apriori algorithm to find frequent itemsets
frequent_itemsets <- apriori(transactions, parameter = list(support = 0.01, target = "frequent itemsets"))

# Print frequent itemsets
inspect(frequent_itemsets)

# Generate association rules
rules <- apriori(transactions, parameter = list(support = 0.01, confidence = 0.1, minlen = 2))
rules <- subset(rules, lift > 1)  # Apply lift filter

# Print association rules
inspect(rules)    
`,

'Seasonal ARIMA': code => `
# Demo of Seasonal ARIMA
# Note: Only two variables "date_col" and "target_col" are changed automatically based on user's option.

if (!requireNamespace("forecast", quietly = TRUE)) {
    install.packages("forecast", quiet = TRUE)
}
if (!requireNamespace("tseries", quietly = TRUE)) {
    install.packages("tseries", quiet = TRUE)
}

suppressMessages(library(forecast))
suppressMessages(library(tseries))

# get "date_col" variable, and our target variable "target_col"
date_col <- "${code.finalX}"
target_col <- "${code.finalY}"

# Ensure the date column is in Date format
df[[date_col]] <- as.Date(df[[date_col]])

# Create time series object
time_series <- ts(df[[target_col]], frequency = 12)  # Monthly data

# Fit a Seasonal ARIMA model (equivalent to Python's SARIMAX)
model <- Arima(time_series, order = c(0,1,0), seasonal = c(1,1,1))

# Print model summary
summary(model)
`
}

// const reconnectErrorFunction = () => {
//   alert('Kernel is taking too much time. Please reduce the data size!')
// }

const reconnectErrorFunction = () => {
  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    background: transparent;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 48px;
    height: 48px;
    border: 5px solid rgba(63, 91, 203, 0.84);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  `;

  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin { to { transform: rotate(360deg); } }
  `;

  document.head.appendChild(style);
  overlay.appendChild(spinner);
  document.body.appendChild(overlay);

  setTimeout(() => {
    overlay.remove();
    style.remove();
  }, 1000);
};


const AnalysisR = () => {
    useCachedData()

    let [optionText, setOptionText] = useState('Select analytic method')
    let [modelText, setModelText] = useState('Select model')
    let [option, setOption] = useState(-1)
    let [model, setModel] = useState(-1)
    let [showSubOptionModal, setShowSubOptionModal] = useState(false)
    // let [predictCode, setPredictCode] = useState(false)
    let [visibleModalTabs, setVisibleModalTabs] = useState([0, 1])
    let [optionButtonVisibility, setOptionButtonVisibility] = useState([1, 1, 1])
    let [currentPresetIndex, setCurrentPresetIndex] = useState(-1)
    let [dfJSON, setDfJSON] = useState('')//dataframe json
    let dataset = useSelector(state => state.dataset)
    let preset = useSelector(state => state.preset)
    let kernelRef = useRef()
    // one kernel per mounted page, shut down again on unmount
    const getPageKernel = usePageKernel(thebeConfigR)
    let [predictVisible, setPredictVisible] = useState(1)
    let dispatch = useDispatch()

    let { getData, result, input } = useSimpleForm({
        default_key: 'default_value'
    })


    let user = useSelector(state => state.auth).user
    let identifier = option + '#' + model
    let presets = getProp(preset, user.id, dataset.filename, identifier) || {}
    let presetsArr = Object.keys(presets)

    let codeParent = useRef()
    let { ref, hide: hideSelections } = useToggleGroup()
    const [code, setCode] = useState('')
    const [activateStatus, setActivateStatus] = useState('Loading...')


    useEffect(() => {
        reconnectErrorFunction();
        if (!code) return

        codeParent.current.innerHTML = ''
        let pre = document.createElement('pre')
        pre.setAttribute('data-executable', 'true')
        pre.setAttribute('data-language', 'R')
        codeParent.current.appendChild(pre)
        pre.innerHTML = code
        let isActive = true

        // Only the freshly created <pre> needs rendering here -- bootstrap() would also
        // request another kernel, and thebe's "status" bus is global, so the handler this
        // used to register kept firing (for every page's kernel) after unmount.
        getPageKernel().then((kernel) => {
            if (!isActive) return
            kernelRef.current = kernel
            kernelRef.current._reconnect = reconnectErrorFunction;
            attachCells(kernel)
            setActivateStatus('Ready')
        }).catch((err) => {
            if (!isActive) return
            console.error('Error connecting to the R kernel:', err)
            setActivateStatus('Error connecting to R')
        })

        return () => { isActive = false }
    }, [code])

    //start thebelab automatically
    //load current dataframe
    useEffect(() => {
        reconnectErrorFunction();
        if (!dataset.filename) {
            setActivateStatus('No data')
            return
        }
        let isActive = true

        // This used to build its own inline copy of thebeConfigR that omitted
        // savedSession, so it cached the same binder server under a different
        // localStorage key than every other R page and never reused theirs.
        //excute code in advance on thebelab to import libraries and set dataframe variable
        getPageKernel().then(async (kernel) => {
            if (!isActive) return
            let res = await fetchByJSON('current_data_json', {
                filename: dataset.filename
            })

            let g = await res.json()
            if (!isActive) return
            kernelRef.current = kernel
            kernelRef.current._reconnect = reconnectErrorFunction;
            setDfJSON(g.data)
            setActivateStatus('Ready')
        }).catch((err) => {
            if (!isActive) return
            console.error('Error connecting to the R kernel:', err)
            setActivateStatus('Error connecting to R')
        })

        return () => { isActive = false }
    }, [dataset.filename])

    const runCode = async (e) => {
        try {
            setActivateStatus('Running Initial code ...');
            let res = await fetchByJSON('current_data_json', {
                filename: dataset.filename
            })

            // let res = await fetch('/file/?filename=' + MethodSampleFile[option] + '&default=' + 'true', {
            //     method: 'GET',
            //     headers: authHeader()
            // })

            let json = await res.json();
            
            let res2 = await kernelRef.current.requestExecute({ code: InitialCode[option](json.data) }).done

            document.querySelector('.thebelab-run-button').click()
            setActivateStatus('Ready');
        } catch (err) {
            console.error("Error during run:", err);
            setActivateStatus('Error during run');
        }
    }

    useEffect(() => {
        result.analysis_option = option
        result.analysis_model = model

        //when option and model changes, set default preset
        // console.log(presetsArr.length ? presetsArr[presetsArr.length-1] : null);
        // setCurrentPreset(presetsArr.length ? presetsArr[presetsArr.length-1] : null)
    }, [option, model, preset])

    let submit = useCallback(async () => {
        dispatch(OptionActions.setOption(['analysis', option, model, { ...result }]))
        let res = await fetchByJSON(`analysis/${option}`, { ...result, filename: dataset.filename })   //send request
        let json = await res.json()     // receive request
        // console.log(json)
        // json.cond.replace(/&/g, ",  ")
        let errorMsg = json['errorMsg']
        if(errorMsg && errorMsg != "''"){
            alert(errorMsg)
        }else{
            // console.log(result)
            setCode(getCodeFromResult(option, model, result, json.do_training))   // demo code
            $('#display_query').text(json.cond.trim())
            $('#display_results').html(json.para_result.trim())
            document.getElementById("img").src = "data:image/png;charset=utf-8;base64," + json.plot_url
            document.querySelector('#model_img_placeholder').classList.add('hidden')
            setShowSubOptionModal(false)
        }
        // console.log(json)   // print
    }, [result, option, model])

    // let onPredict = useCallback(async () => {
    //     dispatch(OptionActions.setOption(['analysis', option, model, { ...result }]))
    //     let res = await fetchByJSON(`analysis/${option}/predict`, {...result, filename:dataset.filename})
    //     let json = await res.json()
    //     console.log(json)
    //     let errorMsg = json['errorMsg']
    //     if(errorMsg && errorMsg != "''"){
    //         alert(errorMsg)
    //     } else {
    //         setCode(getCodeFromResult(option, model+' Prediction', result))
    //         $('#display_query').text(json.cond.trim())
    //         $('#display_results').html(json.predict_result.trim())
    //         setShowSubOptionModal(false)
    //     }
    // }, [result, option, model])


    let OptionView = OptionModels.hasOwnProperty(option) && OptionModels[option].hasOwnProperty(model) ? OptionModels[option][model] : e => <div></div>
    let currentPreset = currentPresetIndex > -1 && currentPresetIndex < presetsArr.length ? presetsArr[currentPresetIndex] : null;

    const selectPreset = (presetIndex, currentResult) => {
        setCurrentPresetIndex(presetIndex)
        dispatch(OptionActions.setOption(['analysis', option, model, { ...currentResult }]))
    }

    const updatePreset = () => dispatch(PresetActions.updatePreset({ userId: user.id, filename: dataset.filename, identifier, presetName: currentPreset, result }))

    const addPreset = () => {
        dispatch(PresetActions.addPreset({ userId: user.id, filename: dataset.filename, identifier, result }))
        setCurrentPresetIndex(presetsArr.length)
    }

    const clearPreset = () => {
        dispatch(PresetActions.clearPreset({ userId: user.id, filename: dataset.filename, identifier }))
        setCurrentPresetIndex(-1)
    }

    const deletePreset = (presetName) => {
        dispatch(PresetActions.deletePreset({ userId: user.id, filename: dataset.filename, identifier, presetName }))
        if (currentPresetIndex >= presetsArr.length) setCurrentPresetIndex(presetsArr.length - 1)
    }
    return (
        <div className='flex flex-col bg-gray-100' style={{ height: 'calc(100% - 4rem)' }}>
            <Modal fixedModalPosition={{
                left: '20vw',
                top: '10vh',
                width: '70vw'
            }} zIndex={11} isOpen={showSubOptionModal} onClose={() => {
                // let data = getData()
                // console.log(data)
            }} setIsOpen={setShowSubOptionModal}>
                <div style={{ zIndex: 1000 }} className="float-right flex justify-end items-center relative right-2 top-2 gap-4">
                    <div>
                        <DropDown zIndex={1000} items={presetsArr} defaultText={'No models'} defaultValue={currentPreset} onSelect={(e, i) => selectPreset(i, presets[e])} deletable={true} onDelete={(e) => {
                            deletePreset(e)
                        }} />
                    </div>
                    {optionButtonVisibility[0] ?
                        <div>
                            <Button width="w-40" text={'Clear models'} onClick={clearPreset} />
                        </div>
                        : null}
                    {optionButtonVisibility[1] ?
                        <div>
                            <Button width="w-40" text={'Update models'} onClick={updatePreset} />
                        </div>
                        : null}
                    {optionButtonVisibility[2] ?
                        <div>
                            <Button width="w-40" text={'Add model'} onClick={addPreset} />
                        </div>
                        : null}
                </div>
                <OptionView visibleTabs={visibleModalTabs} dataset={dataset} result={result} submit={submit} />
            </Modal>


            <div className="flex flex-row h-auto w-full items-start justify-start bg-gray-100 shadow-md py-4 px-4 box-border">
                <div className='mx-5 w-12/12 w-full flex justify-between'>
                    <div className='flex flex-row'>
                        <div className='w-72'>
                            <DropDown ref={ref} text={optionText} width='w-72' items={
                                Object.keys(OptionModels).map((item, i) => ({
                                    name: item, onClick(e) {
                                        {/*   0                           1                            2                               3                 4    */ }
                                        setOption(item)
                                        setOptionText(item)
                                        setPredictVisible(item != 'clustering' && item != 'associate_rule')
                                        return false
                                    }
                                }))} />
                        </div>
                        <div className='w-72 mx-5'>
                            <DropDown ref={ref} zIndex={9} defaultText='Select model' width='w-72' items={
                                (OptionModels.hasOwnProperty(option) ? Object.keys(OptionModels[option]) : []).map((item, i) => ({
                                    name: item, onClick(e) {
                                        setModel(item)
                                        setModelText(item)
                                        setShowSubOptionModal(true)
                                        setVisibleModalTabs([0, 1])
                                        return false
                                    }
                                }))} />
                        </div>
                    </div>
                    
                    <div className='w-auto flex justify-center items-center px-1'>
                        <div className={``}>{activateStatus}</div>
                        <InlineTip zIndex={10} info='The loading status of a remote environment, python code will be executed in that environment as soon as it is ready.' />
                    </div>

                    <div>
                        <ButtonGroup buttons={[
                            {
                                text: 'Training Model',
                                onClick: () => {
                                    if (model) {
                                        setOptionButtonVisibility([1, 1, 1])
                                        setShowSubOptionModal(true)
                                        setVisibleModalTabs([0, 1])
                                    }
                                }
                            },
                            {
                                text: 'Predict',
                                onClick: () => {
                                    if (model) {
                                        setOptionButtonVisibility([0, 0, 0])
                                        setShowSubOptionModal(true)
                                        setVisibleModalTabs([2])
                                    }
                                },
                            },
                            {   
                                disabled:!code,
                                text: 'Run', 
                                onClick: runCode,
                            },
                        ]} />

                        {/* <Button onClick={() => {
                            runCode()
                        }} disabled={!code} width='w-32' text="SandBox Run" overrideClass={`ml-5  px-4 py-1 rounded font-semibold border focus:outline-none text-black cursor-pointer ${!code
                            ? 'text-gray-400 cursor-default' : 'text-black cursor-pointer'}`} customStyle={{ backgroundColor: !!code ? '#4bd699' : 'inherit' }} onClick={runCode} hoverAnimation={false} /> */}
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-nowrap">
                <div className='w-1/2 text-gray-500 font-semibold'>
                    <div className='scroll'>
                        <Label customStyle="p-4 gap-8" itemPos="start" text="Model Conditions:" className='w-300'>
                            <div id="display_query" style={{ whiteSpace: 'pre-wrap' }} >Select a model to see the model conditions</div>
                        </Label>
                        <Label customStyle="p-4 gap-8" itemPos="start" text="Model Results:">
                            <div id="display_results" style={{ whiteSpace: 'pre-wrap' }} >Select a model to see the model results</div>
                        </Label>

                        <Label customStyle="p-4 gap-8" itemPos="start" text="Model Plot:">
                            <img id="img" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
                            <div id="model_img_placeholder">Select a model to see the model plot</div>
                        </Label>
                    </div>
                </div>
                <div className='flex-grow-1 w-1/2' ref={codeParent}>
                    {code ? code : <div className='w-full flex-grow-0 h-48 flex justify-center items-center text-gray-500 font-semibold'>
                        Select a model to see the corresponding code
                    </div>}
                </div>
            </div>
        </div>


    )
}

export default AnalysisR

